import React, { memo } from 'react';

import { Box, Container, Tab, Tabs, TextField, Typography } from '@material-ui/core';

import type { EmaCurationListStatus } from '../../../types/dtos/ema';
import EmaCurationsTable from './EmaCurationsTable';
import EmaCurationsStatusToggle from './EmaCurationsStatusToggle';
import Styles from './EMACurations.styles';
import useEmaCurationsList from './useEmaCurationsList';
import useEmaCurationsStatus from './useEmaCurationsStatus';

const EMACurations = () => {
  const classes = Styles();
  const { status, search, state, actions } = useEmaCurationsList();
  const curationStatus = useEmaCurationsStatus();

  return (
    <Container className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.title} variant='h4' component='h1'>
          EMA Curations
        </Typography>
        <EmaCurationsStatusToggle
          currentStatus={curationStatus.currentStatus}
          pendingStatus={curationStatus.pendingStatus}
          isUpdating={curationStatus.isUpdating}
          selectStatus={curationStatus.selectStatus}
          closeDialog={curationStatus.closeDialog}
          confirmStatusChange={curationStatus.confirmStatusChange}
        />
      </Box>

      <Box className={classes.controls}>
        <Tabs
          className={classes.tabs}
          value={status}
          onChange={(_, nextStatus: EmaCurationListStatus) => actions.selectStatus(nextStatus)}
          aria-label='EMA curation lifecycle'>
          <Tab value='incomplete' label='Pending Curations' />
          <Tab value='complete' label='Completed Curations' />
        </Tabs>

        <TextField
          className={classes.search}
          variant='outlined'
          type='search'
          label='Search App Number'
          value={search}
          onChange={event => actions.setSearch(event.target.value)}
        />
      </Box>

      <Typography className={classes.resultCount}>
        {state.total} {state.total === 1 ? 'curation' : 'curations'}
      </Typography>

      <EmaCurationsTable
        rows={state.rows}
        loading={state.loading}
        actionsEnabled={status === 'complete' || curationStatus.currentStatus === 'processing'}
        onNavigate={actions.navigateToSubflow}
      />
    </Container>
  );
};

export default memo(EMACurations);
